'use strict'
var unitas = unitas || {}

unitas.travelrequest =
  unitas.travelrequest ||
  (function () {
    const tripTypeRadios = document.getElementsByName('tripType')
    const returnDateField = document.getElementById('js-return-date')
    const multiStopShowFields = document.querySelectorAll(
      '.js-addmore-btn, .js-deleterow'
    )
    const multiStopHideFields = document.querySelectorAll(
      '.js-disclaimer-text, .js-direct-flight'
    )

    function init() {
      if (
        document
          .querySelector('.page-form__content')
          ?.classList.contains('no-travelform')
      ) {
        checkTravelFormVisibility()
      }

      if (
        !document
          .querySelector('.page-form__content')
          ?.classList.contains('no-travelform')
      ) {
        setupReturnFieldDisplay()
        setupMultiStopFieldsDisplay()
        setupFlightSegmentAddition()
        updateURLWithParametersOnButtonClick()
        setupMultiStopRowClass()
        updateSummaryBasedOnURL()
      }
    }

    function checkTravelFormVisibility() {
      const pageContentElement = document.querySelector('.page-form__content')
      const formContentElement = document.querySelector(
        '.page-form__formcontent'
      )

      if (pageContentElement && formContentElement) {
        // Check if the element has the 'no-travelform' class
        if (pageContentElement.classList.contains('no-travelform')) {
          // Do not hide the form content by default if the class is present
          formContentElement.style.display = 'flex'
        } else {
          // Otherwise, you can set the form content display as needed
          formContentElement.style.display = 'none'
        }
      }
    }

    function setupMultiStopRowClass() {
      const multiStopRadio = document.getElementById('multiStop')
      const firstRow = document.querySelector('.page-form__inputs:first-child')

      // Initial check in case the page loads with multi-stop already selected
      if (multiStopRadio.checked) {
        firstRow.classList.add('multi-stop-selected')
      }

      // Listen for changes on the radio buttons
      document.getElementsByName('tripType').forEach((radio) => {
        radio.addEventListener('change', () => {
          if (multiStopRadio.checked) {
            firstRow.classList.add('multi-stop-selected')
          } else {
            firstRow.classList.remove('multi-stop-selected')
          }
        })
      })
    }

    function setupReturnFieldDisplay() {
      Array.from(tripTypeRadios).forEach(function (radio) {
        radio.addEventListener('change', function () {
          toggleReturnDateField()
          toggleMultiStopFieldsDisplay()
          toggleReturnFieldRequirement()
        })
      })
    }

    function setupMultiStopFieldsDisplay() {
      toggleMultiStopFieldsDisplay()
    }

    function toggleReturnDateField() {
      var isReturnSelected = document?.getElementById('return').checked
      returnDateField.style.display = isReturnSelected ? 'block' : 'none'
    }

    function toggleReturnFieldRequirement() {
      const isReturnSelected = document.getElementById('return')
      const returnField = document.querySelector('[name="return"]')

      if (returnField) {
        if (isReturnSelected && isReturnSelected.checked) {
          returnField.setAttribute('required', 'required')
          returnField.parentElement.style.display = ''
        } else {
          returnField.removeAttribute('required')
          returnField.parentElement.style.display = 'none'
          returnField.value = ''
        }
      }
    }

    function toggleMultiStopFieldsDisplay() {
      var isMultiStopSelected = document.getElementById('multiStop').checked

      multiStopShowFields.forEach(function (field) {
        field.style.display = isMultiStopSelected ? 'block' : 'none'
      })

      multiStopHideFields.forEach(function (field) {
        field.style.display = isMultiStopSelected ? 'none' : 'flex'
      })

      if (!isMultiStopSelected) {
        clearFlightSegments()
      }
    }

    function setupFlightSegmentAddition() {
      const addMoreButton = document.querySelector('.js-addmore-btn')
      if (addMoreButton) {
        addMoreButton.addEventListener('click', addFlightSegment)
      } else {
        console.error('Add more button not found.')
      }
    }

    function addFlightSegment() {
      const container = document.querySelector('.page-form__inputcontainer')
      const originalRow = container.querySelector(
        '.page-form__inputs:first-child'
      )

      const clone = originalRow.cloneNode(true)

      const inputs = clone.querySelectorAll('input')
      inputs.forEach((input) => (input.value = ''))

      const existingRemoveButton = clone.querySelector('.js-deleterow')
      if (existingRemoveButton) {
        existingRemoveButton.remove()
      }

      const removeButton = document.createElement('button')
      removeButton.type = 'button'
      removeButton.innerHTML = `
        <span>Remove row</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.443848" y="1.63599" width="2" height="20" transform="rotate(-45 0.443848 1.63599)" fill="#282828"/>
          <rect x="14.5857" y="0.221802" width="2" height="20" transform="rotate(45 14.5857 0.221802)" fill="#282828"/>
        </svg>`
      removeButton.className = 'page-form__deleterow js-deleterow'
      removeButton.style.display = 'flex'
      removeButton.addEventListener('click', function () {
        clone.remove()
      })

      clone.appendChild(removeButton)

      container.appendChild(clone)
    }

    function clearFlightSegments() {
      const container = document.querySelector('.page-form__inputcontainer')
      const rows = container.querySelectorAll(
        '.page-form__inputs:not(:first-of-type)'
      )

      rows.forEach((row) => {
        row.remove()
      })
    }

    function updateSummaryBasedOnURL() {
      const params = new URLSearchParams(window.location.search)
      const summaryContainer = document.querySelector('.page-form__summary')
      // Ensure this targets where you want the dynamic segments to go. If needed, add a container in your HTML.
      const dynamicSegmentsContainer = document.createElement('div')
      dynamicSegmentsContainer.className = 'dynamic-segments'

      // Clear previous dynamic content but preserve other static content like titles
      const existingDynamicSegments =
        summaryContainer.querySelector('.dynamic-segments')
      if (existingDynamicSegments) {
        summaryContainer.removeChild(existingDynamicSegments)
      }

      const tripType = params.get('tripType') || 'Not specified'
      // Updating the trip type dynamically; if it's outside the dynamic container, target it specifically
      let tripTypeEl = summaryContainer.querySelector('.js-type')
      if (tripTypeEl) {
        tripTypeEl.textContent = tripType
      }

      // Repeat the process for airports, destinations, etc., as in previous function
      const airports = params.get('airport')
        ? params.get('airport').split(',')
        : []
      const destinations = params.get('destination')
        ? params.get('destination').split(',')
        : []
      const departures = params.get('departure')
        ? params.get('departure').split(',')
        : []
      const returnDates = params.get('return')
        ? params.get('return').split(',')
        : [] // Adjust based on actual parameter use

      airports.forEach((airport, index) => {
        const departure = departures[index] || 'Not specified'
        const destination = destinations[index] || 'Not specified'
        const returnDate = returnDates[index] || 'Not specified'

        const segment = createSummarySegment({
          departure,
          airport,
          destination,
          returnDate,
        })
        dynamicSegmentsContainer.appendChild(segment)
      })

      summaryContainer.appendChild(dynamicSegmentsContainer)
    }

    function createSummarySegment({
      departure,
      airport,
      destination,
      returnDate,
    }) {
      const segment = document.createElement('div')
      segment.className = 'page-form__summaryitem'

      let dateFlexDiv = document.createElement('div')
      dateFlexDiv.className = 'page-form__summaryflex'

      let departureDiv = document.createElement('div')
      departureDiv.innerHTML = `<p class="page-form__summarylabel">Departure</p><p class="page-form__summarytext js-date">${
        departure || 'Not specified'
      }</p>`

      let returnDiv = document.createElement('div')
      if (returnDate && returnDate !== 'Not specified') {
        // Adjust based on how you want to handle not specified returns
        returnDiv.innerHTML = `<p class="page-form__summarylabel">Return: </p><p class="page-form__summarytext">${returnDate}</p>`
      }

      dateFlexDiv.appendChild(departureDiv)
      dateFlexDiv.appendChild(returnDiv)

      let locationFlexDiv = document.createElement('div')
      locationFlexDiv.className = 'page-form__summaryflex'

      let fromDiv = document.createElement('div')
      fromDiv.innerHTML = `<p class="page-form__summarylabel">From</p><p class="page-form__summarytext js-from">${
        airport || 'Not specified'
      }</p>`

      let toDiv = document.createElement('div')
      toDiv.innerHTML = `<p class="page-form__summarylabel">To</p><p class="page-form__summarytext js-to">${
        destination || 'Not specified'
      }</p>`

      locationFlexDiv.appendChild(fromDiv)
      locationFlexDiv.appendChild(toDiv)

      segment.appendChild(dateFlexDiv)
      segment.appendChild(locationFlexDiv)

      return segment
    }

    /* function checkUrlParamsAndAdjustFormVisibility() {
      const urlParams = new URLSearchParams(window.location.search);
      const customForm = document.querySelector('.page-form__customform');
      const gravityForm = document.querySelector('.page-form__formcontent');

      if (urlParams.has('tripType')) {
        if (customForm) customForm.style.display = 'none';
        if (gravityForm) gravityForm.style.display = 'flex';
      }
    } */

    function updateURLWithParametersOnButtonClick() {
      const form = document.querySelector('.page-form__travel')
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault()

          let params = new URLSearchParams()

          // Handling directFlight checkbox
          const isDirectFlightChecked =
            document.getElementById('directOnly').checked
          params.set('directFlight', isDirectFlightChecked ? 'Yes' : 'No')

          // Handling tripType radio buttons
          const tripTypeSelected = document.querySelector(
            'input[name="tripType"]:checked'
          )?.value
          if (tripTypeSelected) {
            params.set('tripType', tripTypeSelected)
          }

          // Initializing collections for airports and destinations
          let airportValues = []
          let destinationValues = []
          let departureValues = []

          // Handle Multi-stop selected scenario
          const isMultiStopSelected =
            document.getElementById('multiStop').checked
          if (isMultiStopSelected) {
            form
              .querySelectorAll('.page-form__inputs')
              .forEach((inputContainer, index) => {
                // Process each input field within the container
                inputContainer
                  .querySelectorAll('input[name], select[name]')
                  .forEach((input) => {
                    // Collect airports
                    if (input.name.includes('airport')) {
                      airportValues.push(input.value)
                    }
                    // Collect destinations
                    else if (input.name.includes('destination')) {
                      destinationValues.push(input.value)
                    }
                    // Collect departures
                    else if (input.name.includes('departure')) {
                      departureValues.push(input.value)
                    }
                  })
              })

            // Set the 'airport' parameter with concatenated values
            if (airportValues.length > 0) {
              params.set('airport', airportValues.join(','))
            }

            // Set the 'destination' parameter with concatenated values
            if (destinationValues.length > 0) {
              params.set('destination', destinationValues.join(','))
            }

            // Optionally, handle 'departure' similarly if needed
            if (departureValues.length > 0) {
              params.set('departure', departureValues.join(','))
            }
          } else {
            // Handle Non-multi-stop scenario (simple form fields appending)
            const formData = new FormData(form)
            formData.forEach((value, key) => {
              if (
                !key.startsWith('airport_') &&
                !key.startsWith('destination_') &&
                !key.startsWith('departure_')
              ) {
                params.set(key, value)
              }
            })
          }

          // Redirect with updated parameters
          window.location.href = `${
            window.location.pathname
          }?${params.toString()}`

          // Adjusting form visibility based on submission
          /* const customForm = document.querySelector('.page-form__customform');
          const formContent = document.querySelector('.page-form__formcontent');
          customForm.style.display = 'none';
          formContent.style.display = 'flex'; */
        })
      }
    }

    return {
      init: init,
    }
  })()
